import "./addSmish.css"
import CustomBtn from '../../components/CustomBtn';
import { readImageFile } from '../../components/readImageFile';
import { uploadMessage } from '../../components/uploadMessage';
import { validateMessage } from "../../components/validateMessage";
import { Button } from "@material-ui/core";
import { Message, Image, Person } from "@material-ui/icons";
import { useState, useEffect } from "react";
import { makeStyles } from "@material-ui/styles";
import { TextareaAutosize } from '@material-ui/core';
import { getUser } from "../../service/AuthService";
import { Backdrop } from '@material-ui/core';
import { CircularProgress } from '@material-ui/core';
import { Tooltip } from "@material-ui/core";

const createPhishUrl = process.env.REACT_APP_CREATE_SMISH_API_URL;
const useStyles = makeStyles((theme) => ({ backdrop: { zIndex: theme.zIndex.drawer + 1, color: '#fff', }, }));

export default function AddSmish(login) {
    useEffect(() => {
        document.title = "Smishtank: Add Smish"
        const getPoster = () => {
            const userName = getUser();
            const posterName = userName !== 'undefined' && userName ? userName.username : '';
            setPoster(posterName);
        }
        getPoster();
    }, []);
    const classes = useStyles();
    const [msgContent, setContent] = useState('');
    const [messageImage, setMessageImage] = useState('');
    const [poster, setPoster] = useState('');
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(false);
    const [selectedImageFile, setImageFile] = useState('');
    const [message, setMessage] = useState(null);
    let messageStyle = {
        color: 'green',
        fontWeight: 'bold'
    };
    if (error) {
        messageStyle = {
            color: 'red',
            fontWeight: 'bold'
        }
    }

    function imageHandler(image) {
        setMessageImage(image.value);
        setImageFile(image.files[0]);
        if (!image.value) {
            setMessageImage('');
            setImageFile('');
        }
    }
    
    const submitHandler = async (event) => {
        event.preventDefault();
        if (loading) {
            return;
        }
        setLoading(true);
        
        const validationResult = validateMessage(messageImage, selectedImageFile, msgContent);

        setLoading(validationResult.loading);
        setError(validationResult.error);
        setMessage(validationResult.message);

        if (validationResult.error) {
            return; // Stop execution if validation fails
        }
        const user = getUser();
        const name = user !== 'undefined' && user ? user.username : '';
        try {
            // Read the image file and get the JSON data


            const requestBody = {
                submitName: name,
            }
            if (selectedImageFile !== '') {
                const jsonData = await readImageFile(selectedImageFile);
                requestBody.image = JSON.stringify(jsonData);
            }

            if (msgContent !== '') {
                requestBody.messageContent = msgContent;
            }

            const requestConfig = {
                headers: {
                    'x-api-key': process.env.REACT_APP_API_GATEWAY_KEY,
                }
            }
            const result = await uploadMessage(createPhishUrl, requestBody, requestConfig, selectedImageFile);

            setLoading(false);
            setError(!result.success);
            setMessage(result.message);
        
            if (result.success) {
                setContent("");
                setImageFile("");
                setMessageImage("");
            }

        } catch (error) {
            console.error(error.message);
        }

    }

    return (
        <div className="addSmish">
            <div className="SmishFormContainer">
                <span className="addSmishtitle">Submission Instruction: Please capture a screenshot of the phishing SMS, upload the screenshot, and click the submit button. Pasting the message text is optional.</span>
                <form onSubmit={submitHandler} className="insertSmishForm" id="submitSmish">
                    <div className="messageInfo">
                        <label className="label-align">
                            <Person className="messageIcon" />
                            <span className="label-align">Submitting As:</span>
                        </label>
                        <Tooltip title="Post anonymously or with your username.">
                            {login.loggedin ? (
                                <label className="label-align">{poster}</label>
                            ) : (
                                <label className="label-align">Anonymous</label>
                            )}
                        </Tooltip>
                    </div>
                    <div className="messageInfo">
                        <label className="label-align">
                            <Image className="messageIcon" />
                            <span className="label-align">Message Screenshot</span>
                        </label>
                        <Tooltip title="We accept images in png or jpg format.">
                            <Button
                                variant="contained"
                                component="label"
                                className="buttonStyle"
                            >
                                Upload Image
                                <input
                                    value={messageImage}
                                    type="file"
                                    accept="image/jpeg,image/png"
                                    placeholder="image path"
                                    className="insertMessageImage"
                                    onChange={event => imageHandler(event.target)}
                                />
                            </Button>
                        </Tooltip>
                    </div>
                    <div className="messageInfo">
                        {messageImage && <span className="label-align">File Path:</span>}
                        {!messageImage && <span className="label-align">&nbsp;</span>}
                        {messageImage && messageImage.split('\\').pop()}
                    </div>
                    <div className="messageInfo">
                        <label className="label-align">
                            <Message className="messageIcon" />
                            <span className="label-align">Message Text (Optional)</span>
                        </label>
                        <Tooltip title="Please input the full message text here.">
                            <TextareaAutosize
                                value={msgContent}
                                aria-label="minimum height"
                                minRows={3}
                                placeholder="Message Contents"
                                className="insertMessageText"
                                onChange={event => setContent(event.target.value)}
                            />
                        </Tooltip>
                    </div>
                    <div className="SmishTitleContainer">
                        <h3 className="addSmishTitle">Add A Smish</h3>
                        <CustomBtn txt="Submit" form="submitSmish" />
                    </div>
                </form>
                {message && <p style={messageStyle}>{message}</p>}
            </div>
            <Backdrop className={classes.backdrop} open={loading}>
                <CircularProgress color="inherit" />
            </Backdrop>
        </div>
    )
}